import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class StorageService implements Storage {
    readonly length: number;
    [key: string]: any;

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor() { }

    clear(): void {
        window.sessionStorage.clear();
    }

    setItem(key: string, value: any): void {
        window.sessionStorage.setItem(key, value);
    }

    key(index: number): string | null {
        return window.sessionStorage.key(index);
    }

    getItem(key: string): string | null {
        return sessionStorage.getItem(key);
    }

    removeItem(key: string): void {
        sessionStorage.removeItem(key);
    }

    getObjectKeys(object: any): string[] {
        return Object.keys(object);
    }

}